<script lang="ts">
    import { langField } from "../../i18n"
    import { breadcrumbs, preselectedDealerNumber } from "../../store"
</script>

{#if $breadcrumbs?.length > 1 && !$preselectedDealerNumber}
    <div id="breadcrumb">
        <ul>
            {#each $breadcrumbs as node}
                <li>
                    <a href="{langField(node.path, '')}">{langField(node.name, "")}</a>
                </li>
            {/each}
        </ul>
    </div>
{/if}

<style lang="less">
    @import "../../css/variables.less";

    #breadcrumb {
        background: var(--background);
        color: var(--on-background);
        border-bottom: solid 1px var(--border-color-default);
        padding: 5px 40px;
        font-size: 0.8rem;
        @media (max-width: 1300px) {
            padding: 5px 20px;
        }
        @media (max-width: 500px) {
            display: none;
        }
        ul {
            list-style-type: none;
            margin: 0px;
            padding: 0px;
            .flex();
            flex-wrap: wrap;
            li {
                color: var(--on-background);
                margin-right: 15px;
                .flex();
                align-items: center;
                &:after {
                    margin-left: 10px;
                    content: "»";
                    font-weight: 700;
                    font-size: 1rem;
                }
                &:last-child:after {
                    display: none;
                }
                a {
                    color: var(--on-background);
                    &:hover {
                        color: var(--primary);
                    }
                }
            }
        }
    }
</style>
